export default {
  isLoudnessDetectorSupported(state, getters, rootState, rootGetters) {
    // Microphone media streams are very fragile on mobile browsers
    return !window.Cypress && !rootGetters.isMobileWebMode;
  }
};
